// extracted by mini-css-extract-plugin
export var errorIcon = "_pu-1";
export var nameLogo = "_pu-0";